module.exports = __webpack_public_path__ + "img/pr-15.584eec72.png";